import { GET_ADMIN_TAGS, TAGS_LOADING } from "../actions/types";

const initialState = {
  list: [],
  tags_loading: false,
};

export default function tagReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ADMIN_TAGS:
      return { ...state, list: action.payload };
    case TAGS_LOADING:
      return { ...state, tags_loading: action.payload };
    default:
      return state;
  }
}
